module.exports = __webpack_public_path__ + "static/media/interface-inventory.bb26160b.gif";